import React, { useContext, useEffect } from 'react'
import { introduction, right_arrow } from '../../images/images';
import SelfieStepper from '../SelfieOld/Stepper/SelfieStepper';
import './Introduction.css'
import { SpeakerContext } from '../../context/SpeakerContext';


function Introduction(props) {
    const { handleAudioIconDisplay } = useContext(SpeakerContext)

  useEffect(()=>{
    setTimeout(()=>{
        handleAudioIconDisplay(false)
    },40)
  },[])

    return (
        <div className="introduction-parent">

            <div className="intro-cntnr">
                <div className='intro-name'>
                    <h3> Welcome {props.proposerFirstname},</h3>
                </div>
                <div className="intro-header">

                    <p className="intro-header-text">
                        Pre-issuance Verification
                    </p>
                    <img className='intro-header-img' src={introduction} alt="" />
                </div>

                <div className="intro-heading-cntnr" >
                    <p className='intro-sub-heading-text'>  Thank you for choosing Axis Max Life {props.productName}. This is a mandatory verification process for your insurance proposal. We request you to go through this information carefully.</p>
                </div>

                <div className="intro-stepper-cntnr">
                    <p className='intro-step'>Your verification process will be completed in {props.isNps == 'Y' || props.journeyBy == "P" ? 1 : props.isVideoPosv == 'Y' ? 4 : props.twoStep == 'Y' ? 2 : 3} easy step :</p>

                    <div className="intro-stepper-msgs">
                        <SelfieStepper orientation="vertical" currentStep="" isNps={props.isNps} hybridPosv={props.isVideoPosv} twoStep={props.twoStep} journeyBy={props.journeyBy} />

                    </div>
                    <div className="intro-btn">
                        <button className='intro-nxt-btn' type="submit" onClick={props.handleVerificationBtn} >Start Your Verification <img className="right-arrow-icon" src={right_arrow} alt="" /></button>
                    </div>


                </div>

            </div>
        </div>
    )
}

export default Introduction;


